export interface SelectionConfig {
  selectionMode: SelectionMode;
  maxItems: number;
  maxDiscountedItems: number;
  showProductHats: boolean;
}

export enum SelectionMode {
  /**
   * Only one product can be selected from the group
   */
  Single = 'single',
  /**
   * Multiple products can be selected from the group
   */
  Multiple = 'multiple',
  /**
   * Like "Multiple" but discounts are only applied for "Max discounted items" (usually set to 1)
   * Logic selects offer with maximum total savings
   */
  BestDiscount = 'bestDiscount',
}
